<template>
  <div class="menu--page">
    <div v-for="(menu, index) in menus" v-show="showMenu(menu)" :key="index" class="menu--button">
      <router-link :to="{name: menu.name}">
        <el-button type="primary" plain round style="width: 100%">
          {{ menu.title.toUpperCase() }}
        </el-button>
      </router-link>
    </div>
    <el-button size="small" type="info" @click="handleLogout">LOGOUT</el-button>
  </div>
</template>

<script>
import { logout } from '@/services/auth'
const configMenus = [
  {
    title: 'View Passenger',
    url: '/admin/passengers',
    name: 'Passengers'
  },
  {
    title: 'Manage Trips',
    url: '/admin/trips',
    name: 'Trips'
  },
  {
    title: 'Location',
    url: '/admin/locations',
    name: 'Location'
  },
  {
    title: 'Drivers',
    url: '/admin/fares',
    name: 'Drivers'
  },
  {
    title: 'Manage Routes',
    url: '/admin/fares',
    name: 'Fares'
  },
  {
    title: 'Inject Passenger',
    url: '/admin/inject-passenger',
    name: 'InjectPassenger'
  },
  {
    title: 'Create Offline Passenger',
    url: '/admin/offline-passenger',
    roles: ['drivers', 'sales_rep'],
    name: 'CreateOfflinePassenger'
  },
  {
    title: 'User Admin',
    url: '/admin/users',
    roles: ['admin'],
    name: 'UserAdmin'
  },
  {
    title: 'Reports Generator',
    name: 'ReportManager'
  }
]
export default {
  name: 'mobile-menu',
  data () {
    const { user } = this.$attrs

    return {
      menus: configMenus,
      userType: user.user_type
    }
  },

  methods: {
    showMenu (menu) {
      const { user } = this.$attrs
      const userType = user.user_type
      if (user.is_superuser) {
        return true
      }
      if (!menu.roles) {
        return false
      }
      return menu.roles.includes(userType)
    },

    handleLogout () {
      logout()
    }
  }
}
</script>

<style>
.menu--page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 80%;
}

.menu--button {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminMobileMenu.vue